import NoAccessPage from './NoAccessPage';

export default NoAccessPage;
